/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Tylko IN_PROGRESS obejmuje pracowników i blokuje konkurencyjne kampanie.
 * @export
 * @enum {string}
 */

export const DevelopmentCycleCampaignStatusDto = {
    Draft: 'DRAFT',
    InProgress: 'IN_PROGRESS',
    Finished: 'FINISHED',
    Cancelled: 'CANCELLED'
} as const;

export type DevelopmentCycleCampaignStatusDto = typeof DevelopmentCycleCampaignStatusDto[keyof typeof DevelopmentCycleCampaignStatusDto];



